const timeDate = require('../../../../../js-handler/time-date')
const dtUpdate = require('./saleDeleted-dt-update')

export function organizeRow(data) {
  if (!data.length) {
    return [{
      id: 'nothing',
      colum: [
        { label: 'No Results', span: '' },
        { label: '', span: '' },
        { label: '', span: '' },
        { label: '', span: '' },
        { label: '', span: '' },
        { label: '', span: '' }
      ]
    }]
  }

  return data.map(sale => {
    const shipping = dtUpdate.getstatusshippingtyle(sale)
    const payment = dtUpdate.getstatuspaymentstyle(sale)

    return {
      id: sale.id,
      colum: [
        {
          label: sale.name,
          span: sale.code,
          style: {
            tdClass: 'tdWithAvatar',
            avatar: './css/svg.svg#delete-o',
            avatarLetter: '',
            svgBg: '#d32f2f'
          }
        },
        { label: `${sale.qty} Units`, span: sale.grand_total_dt },
        {
          label: timeDate.friendlyDate(sale.sale_date_td),
          span: timeDate.friendlyDate(sale.due_date_td)
        },
        {
          label: timeDate.friendlyDate(sale.packing_slip_last_printed),
          span: timeDate.friendlyTime(sale.packing_slip_last_printed_time)
        },
        {
          label: shipping.label_top,
          span: shipping.desc,
          style: {
            tdClass: `tdWithIcon ${shipping.icon.color}`,
            svg: `./css/svg.svg#${shipping.icon.svg}`
          }
        },
        {
          label: payment.label_top,
          span: payment.desc,
          style: {
            tdClass: `tdWithIcon ${payment.icon.color}`,
            svg: `./css/svg.svg#${payment.icon.svg}`
          }
        }
      ]
    }
  })
}
